import { getJSONSchemaURL, Y42MetadataGitModel } from '@y42/feature/json-schema';
import { AbstractFeatureStoreModelWithChildren, AbstractFeatureUIModel, UserRelatedData } from '@y42/feature/models';
import { FeatureListViewData } from '@y42/feature/shared/list-view';
import { VisualizationDashboardSettings } from '@y42/json-schema';
import type { VisualizationTabStoreModel, VisualizationTabUIModel } from '../tab/visualization-tab.model';

export class VisualizationDashboardSettingsGitModel extends VisualizationDashboardSettings {
  constructor(model?: VisualizationDashboardStoreModel) {
    super();
    const settings = model?.settings;
    this.$schema = getJSONSchemaURL('visualization-dashboard-settings');
    this.theme = settings?.theme ?? '';
    this.order = settings?.order ?? [];
    this.last_used_datasource_table_path = settings?.last_used_datasource_table_path;
    this.enable_cross_filtering = settings?.enable_cross_filtering ?? true;
  }
  /**
   * DO NOT MODIFY ANY PROPERTIES HERE.
   * TO LEARN HOW TO MODIFY CLASSES GENERATED FROM JSON-SCHEMA
   * TAKE A LOOK AT https://y42-com.slab.com/posts/working-with-json-schemas-1hz2gcvj
   */
}

export class VisualizationDashboardStoreModel
  extends Y42MetadataGitModel
  implements AbstractFeatureStoreModelWithChildren
{
  constructor(model: VisualizationDashboardStoreModel) {
    super(model);
    this.$name = model.$name;
    this.$path = model.$path;
    this.$level = model.$level;
    this.$children = model.$children;

    this.settings = model.settings;
  }

  $name: string;
  $path: string;
  $level: number;
  $children: Array<VisualizationTabStoreModel['$path']>;

  settings: VisualizationDashboardSettingsGitModel;
}

export type VisualizationDashboardUIModel = AbstractFeatureUIModel &
  VisualizationDashboardStoreModel &
  Partial<UserRelatedData> & {
    tabs: VisualizationTabUIModel[];
  };

export type VisualizationDashboardListViewData = FeatureListViewData<
  VisualizationDashboardUIModel & {
    numberOfWidgets: number;
  },
  VisualizationTabUIModel
>;
